/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
export const useSubRowSelection = (hooks) => {
    hooks.useInstance.push(useInstance);
};
const useInstance = (instance) => {
    const selectedFlatRows = React.useMemo(() => {
        const selectedFlatRows = [];
        const setSelectionState = (row, selectedRowIds) => {
            let isSomeSubRowsSelected = false;
            row.subRows.forEach((subRow) => {
                setSelectionState(subRow, selectedRowIds);
                if (subRow.isSelected || subRow.isSomeSelected) {
                    isSomeSubRowsSelected = true;
                }
            });
            if (selectedRowIds[row.id]) {
                row.isSelected = true;
                row.isSomeSelected = false;
                selectedFlatRows.push(row);
            }
            else {
                row.isSelected = false;
                row.isSomeSelected = isSomeSubRowsSelected;
            }
        };
        instance.rows.forEach((row) => setSelectionState(row, instance.state.selectedRowIds));
        return selectedFlatRows;
    }, [instance.rows, instance.state.selectedRowIds]);
    Object.assign(instance, {
        selectedFlatRows,
    });
};
